import { TAB_LOT_AND_ELEVATION, TAB_FLOOR_PLAN_CONFIG } from '../constants';

/**
 * Maps the Floor Plan Detail view's own tab constants (constants.js) to the wire-format values
 * the tracking spec expects (Jira NHS20-8252's AC table: 'lot_elevation',
 * 'floor_plan_configuration'). Shared by both segmentEventBuilder.js and
 * googleAnalytics4EventBuilder.js so the two providers can never drift on what the same tab is
 * called. Kept separate from tabTrackingValue.js, which is scoped to the Available chip's Floor
 * Plans/Quick Move-Ins tabs (NHS20-8249) — a different tab group entirely.
 * @type {Record<string, string>}
 */
const FLOOR_PLAN_DETAIL_TAB_TRACKING_VALUES = {
  [TAB_LOT_AND_ELEVATION]: 'lot_elevation',
  [TAB_FLOOR_PLAN_CONFIG]: 'floor_plan_configuration',
};

/**
 * @param {string|null} tab - one of constants.js's TAB_LOT_AND_ELEVATION/TAB_FLOOR_PLAN_CONFIG, or null
 * @returns {string|null}
 */
export default function getFloorPlanDetailTabTrackingValue(tab) {
  return FLOOR_PLAN_DETAIL_TAB_TRACKING_VALUES[tab] ?? null;
}
